<template>
  <div style="width: 100%; float: right" class="fill-height">
    <v-container>
      <v-row v-if="listView" class="justify-center">
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <!-- Sticky Header -->
          <div class="mi-sticky-header">
            <div class="controls-row">
              <v-select
                v-if="location !== {}"
                outlined
                dense
                hide-details
                label="Prodajno mjesto"
                :items="locations"
                item-text="name"
                item-value="id"
                v-model="location"
                @change="resetInfinite()"
                class="filter-select controls-location"
              ></v-select>
              <v-spacer></v-spacer>
              <v-btn class="add-item-btn" elevation="0" @click="openAddMenuItem">
                <v-icon small class="mr-1">mdi-plus</v-icon>Dodaj artikl
              </v-btn>
            </div>
            <div class="mi-thead">
              <div style="width:6%;"></div>
              <div class="mi-thead-cell" style="width:33%;">Naziv artikla</div>
              <div class="mi-thead-cell" style="width:16%;">Cijena</div>
              <div class="mi-thead-cell" style="width:12%;">Šifra</div>
              <div class="mi-thead-cell" style="width:10%;">Stanje</div>
              <div class="mi-thead-cell" style="width:10%;">Status</div>
              <div class="mi-thead-cell" style="width:8%;">Prodaje se</div>
              <div style="width:5%;"></div>
            </div>
          </div>

          <!-- Rows -->
          <div class="mi-rows-body">
            <div
              v-for="(item, i) in items"
              :key="i"
              :class="['mi-row', getRowClass(item.status)]"
            >
              <div class="mi-row-inner">
                <div class="mi-cell-img" style="width:6%;">
                  <v-img
                    v-if="item.picture"
                    :src="item.picture"
                    contain
                    width="44"
                    height="44"
                    style="border-radius:6px; margin-right:16px;"
                  ></v-img>
                  <div v-else style="width:44px; height:44px; border-radius:6px; background:#F1F5F9; margin-right:16px;"></div>
                </div>
                <div class="mi-cell" style="width:33%;">
                  <span
                    class="item-name one-liner-text"
                    @mouseover="hoverOver(`hover-${item.id}`, item)"
                    @mouseleave="item[`hover-${item.id}`] = false"
                    :id="`hover-${item.id}`"
                    :ref="`hover-${item.id}`"
                  >{{ $options.filters.capitalize(item.name) }}</span>
                  <v-tooltip v-model="item[`hover-${item.id}`]" bottom>
                    <template v-slot:activator="{ on }"><div v-on="on"></div></template>
                    <div style="max-width: 300px">{{ item.name }}</div>
                  </v-tooltip>
                </div>
                <div class="mi-cell" style="width:16%;">
                  <span v-for="p in item.prices" :key="p.currency">
                    <span v-if="item.manual_price_input">- {{ p.currency }}</span>
                    <span v-else>{{ p.price | money(100, p.currency) }}</span>
                  </span>
                </div>
                <div class="mi-cell" style="width:12%;">{{ item.code }}</div>
                <div class="mi-cell" style="width:10%;">{{ item.type === 'GOODS' ? item.stock : '-' }}</div>
                <div class="mi-cell" style="width:10%;">
                  <v-chip x-small :class="getStatusChipClass(item.status)">{{ showStatus(item.status) }}</v-chip>
                </div>
                <div class="mi-cell" style="width:8%;">
                  <v-chip x-small :class="item.active ? 'active-chip-yes' : 'active-chip-no'">{{ item.active ? 'DA' : 'NE' }}</v-chip>
                </div>
                <div class="mi-cell-actions" style="width:5%;">
                  <v-menu offset-y left>
                    <template #activator="{ on, attrs }">
                      <v-btn icon small v-on="on" v-bind="attrs"><v-icon size="18" color="#94A3B8">mdi-dots-vertical</v-icon></v-btn>
                    </template>
                    <v-list dense class="mi-kebab-list">
                      <v-list-item @click="openEditForm(item)" class="mi-menu-item">
                        <v-icon small color="#3989C9" class="mr-2">mdi-pencil</v-icon>
                        <v-list-item-title class="mi-menu-title mi-menu-edit">Uredi</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-else
        class="d-flex justify-center align-center flex-wrap fill-height ma-0 pa-0"
      >
        <v-card
          class="menu-item-grid-card ma-4"
          v-for="(item, i) in items"
          :key="i"
          hover
          height="320"
          width="250"
        >
          <div
            class="menu-item-grid-header"
            :class="[
              item.status === 'OK'
                ? 'status-ok-header'
                : item.status === 'PROCESSING'
                  ? 'status-processing-header'
                  : 'status-failed-header'
            ]"
          >
            <v-img
              height="165"
              width="250"
              v-if="item.picture"
              :src="item.picture"
              class="menu-item-grid-image"
            >
            </v-img>
            <div v-else class="no-image-placeholder">
              <v-icon size="64" color="rgba(57, 137, 201, 0.3)">mdi-image-off</v-icon>
            </div>
          </div>
          <div class="menu-item-grid-content">
            <h3 class="menu-item-grid-title one-liner-text">
              {{ $options.filters.capitalize(item.name) }}
            </h3>
            <p
              class="menu-item-grid-status one-liner-text"
              :class="[
                item.status === 'OK'
                  ? 'status-text-ok'
                  : item.status === 'PROCESSING'
                    ? 'status-text-processing'
                    : 'status-text-failed'
              ]"
            >
              Status: {{ showStatus(item.status) }}
            </p>
            <p class="menu-item-grid-price one-liner-text">
              <span v-for="p in item.prices" :key="p.currency">
                Cijena: {{ p.price | money(100, p.currency) }}
              </span>
            </p>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="menu-item-grid-actions">
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  icon
                  color="#3989C9"
                  @click="openEditForm(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Uredi artikl</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-row>
      <infinite-loading
        ref="InfiniteLoading"
        @infinite="infiniteHandler"
        spinner="waveDots"
      >
        <div slot="no-more" class="text--secondary font-italic"></div>
        <div slot="no-results" class="text--secondary font-italic"></div>
      </infinite-loading>
    </v-container>
    <add-menu-item
      @refresh="refresh"
      ref="addMenuItem"
      @success="refreshPriceList"
    ></add-menu-item>
    <edit-menu-item
      @refresh="refresh"
      ref="editMenuItem"
      @success="refreshPriceList"
    ></edit-menu-item>
  </div>
</template>
<script>
import { auth, df } from '@/plugins/firebase'
import state from '@/state'
import addMenuItem from '@/modules/point-of-sale/components/menu-item/AddMenuItem'
import editMenuItem from '@/modules/point-of-sale/components/menu-item/EditMenuItem'

import InfiniteLoading from 'vue-infinite-loading'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import barcodeChecker from '@/mixins/barcodeChecker'
import { clone } from '@/plugins/utils'

export default {
  name: 'Pricelist',
  inject: ['showLoader', 'hideLoader', 'showMsgBox'],
  mixins: [flow, applicationSettings, barcodeChecker],
  components: { addMenuItem, InfiniteLoading, editMenuItem },
  data: () => ({
    dialog: false,
    loading: false,
    totalArticles: 0,
    lastVisible: '',
    multiplier: 0,
    lastiItem: false,
    items: [],
    sortedItems: [],
    warehouseModule: false,
    location: undefined,
    locations: [],
    listeners: []
  }),
  computed: {
    listView () {
      return state.isListView()
    },
    search () {
      return state.search
    }
  },
  mounted () {
    this.getAllCurrentCompanyPointsOfSale()
    if (state.getCurrentCompany().warehouse === 'module') {
      this.warehouseModule = true
    }

    this.location = state.getPointOfSale().id
    this.resetInfinite()
    this.getMultiplier()
  },
  watch: {
    listView (nv, ov) {
      if (nv !== ov) {
        if (this.$refs.InfiniteLoading) {
          this.$refs.InfiniteLoading.stateChanger.reset()
        }
      }
    },
    search () {
      this.lastVisible = ''
      this.items = []
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    }
  },
  methods: {
    getRowClass (status) {
      if (!status) return 'status-failed'
      const s = status.toUpperCase()
      if (s === 'OK') return 'status-ok'
      if (s === 'PROCESSING') return 'status-warn'
      return 'status-failed'
    },
    getStatusChipClass (status) {
      if (!status) return 'status-chip-failed'
      const s = status.toUpperCase()
      if (s === 'OK') return 'status-chip-ok'
      if (s === 'PROCESSING') return 'status-chip-warn'
      return 'status-chip-failed'
    },
    showStatus (status) {
      switch (status) {
        case 'OK':
          return 'Aktivan'
        case 'PROCESSING':
          return 'Procesira se'
        case 'FAILED':
          return 'Greška'
        default:
          return status
      }
    },
    refresh () {
      this.items = []
      this.lastVisible = ''
      this.detachListeners()
      this.resetInfinite()
    },
    resetInfinite () {
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    },
    getAllCurrentCompanyPointsOfSale () {
      const docRef = df.doc(`user_locations/${auth.currentUser.uid}.${state.getCurrentCompany().id}`)
      docRef.onSnapshot(doc => {
        var locations = Object.values(doc.data().locations)
        locations.forEach((location, index) => {
          this.locations.push(location)
        })
      })
      this.locations.push({ name: 'Sva', location_id: 'all' })
    },
    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].clientHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },
    openDialog () {
      this.dialog = true
    },
    openAddMenuItem () {
      this.$refs.addMenuItem.open()
    },
    openEditForm (item) {
      this.$refs.editMenuItem.open(item)
    },
    refreshPriceList (item) {
      this.$forceUpdate()
    },
    modifyItems (change) {
      if (change.type === 'added') {
        const d = change.doc.data()
        d.stock = d.stock / this.multiplier
        d.stock = d.stock.toString().replace('.', ',')
        if (d.prices) {
          Object.keys(d.prices).forEach(key => {
            d.prices[key].currency = key
          })
        }
        this.items.push({ ...d, ...{ [`hover-${change.doc.data().id}`]: false } })
      }

      if (change.type === 'modified') {
        this.items = this.items.map(item => {
          let ret = item
          if (item.id === change.doc.data().id) {
            ret = change.doc.data()
            ret.stock = ret.stock / this.multiplier
            ret.stock = ret.stock.toString().replace('.', ',')
          }
          if (ret.prices) {
            Object.keys(ret.prices).forEach(key => {
              ret.prices[key].currency = key
            })
          }
          return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
        })
      }

      this.sortedItems = clone(this.items.sort((a, b) => a.name.localeCompare(b.name)))
    },
    infiniteHandler ($state) {
      let search = 'name'
      if (this.isBarcodeSearch(this.search)) {
        search = 'barcode'
      }

      const where = this.search ? this.search.toLowerCase() : ''

      let query = df.collection(`location_menu_pricelist/${this.location}/items`)
        .orderBy(search, 'asc')
        .limit(10)
        .startAfter(this.lastVisible)

      if (where) {
        query = query.where(search, '>=', where).where(search, '<=', where + '\uf8ff')
      }

      const listener = query
        .onSnapshot((doc) => {
          doc.docChanges().forEach((change) => {
            this.modifyItems(change)
          })
          if (doc && !doc.empty) {
            if (doc.docs[doc.docs.length - 1]) {
              this.lastVisible = doc.docs[doc.docs.length - 1]
            }
            $state.loaded()
          } else {
            $state.complete()
          }
        }
        // (error) => {
        // }
        )

      this.listeners.push(listener)
    },
    getMultiplier () {
      const listener = df.doc('project_constants/config').onSnapshot(doc => {
        this.config = doc.data()
        this.multiplier = doc.data().item_amount.decimal_multiplier
      })
      this.listeners.push(listener)
    }
  }
}
</script>
<style scoped>
/* Sticky Header */
.mi-sticky-header {
  position: sticky;
  top: 64px;
  z-index: 10;
  background: #ffffff;
  padding: 14px 0 0;
  border-left: 3px solid #00BCD4;
  border-bottom: 1px solid #EEF2F5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.03);
}

.controls-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px 16px;
}

.controls-location {
  max-width: 260px;
}

.add-item-btn {
  background: #00BCD4 !important;
  color: #ffffff !important;
  font-weight: 600;
  font-size: 13px;
  height: 36px !important;
  border-radius: 8px !important;
  letter-spacing: 0.3px;
  white-space: nowrap;
  flex-shrink: 0;
}

.mi-thead {
  display: flex;
  align-items: center;
  padding: 0 0 8px 16px;
  border-left: 3px solid transparent;
}

.mi-thead-cell {
  font-size: 12px;
  font-weight: 600;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 8px;
  flex-shrink: 0;
}

/* Rows */
.mi-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.mi-row {
  display: flex;
  align-items: stretch;
  border: 1px solid #EEF2F5;
  border-left: 3px solid #E0E0E0;
  border-radius: 6px;
  background: #ffffff;
  transition: border-left-color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
  min-height: 60px;
  margin-bottom: 4px;
  overflow: hidden;
}

.mi-row:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.mi-row.status-ok  { border-left-color: #4ADE80 !important; }
.mi-row.status-warn { border-left-color: #FBBF24 !important; }
.mi-row.status-failed { border-left-color: #F87171 !important; }

.mi-row-inner {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 0 0 16px;
}

.mi-cell-img {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.mi-cell {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
  padding: 0 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}

.mi-cell-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Status chips */
.status-chip-ok     { background: #DCFCE7 !important; color: #166534 !important; font-weight: 600 !important; }
.status-chip-warn   { background: #FEF9C3 !important; color: #854D0E !important; font-weight: 600 !important; }
.status-chip-failed { background: #FEE2E2 !important; color: #991B1B !important; font-weight: 600 !important; }
.active-chip-yes    { background: #DCFCE7 !important; color: #166534 !important; font-weight: 600 !important; }
.active-chip-no     { background: #FEE2E2 !important; color: #991B1B !important; font-weight: 600 !important; }

/* Kebab menu */
.mi-kebab-list { border-radius: 8px !important; padding: 4px 0 !important; }
.mi-menu-item  { min-height: 36px !important; padding: 0 12px !important; }
.mi-menu-title { font-size: 13px !important; font-weight: 500 !important; }
.mi-menu-edit  { color: #3989C9 !important; }

/* Filter select */
.filter-select >>> .v-input__slot { min-height: 36px !important; }

/* Grid View — unchanged cards */
.menu-item-grid-card {
  background: #ffffff;
  border-radius: 12px !important;
  border: 1px solid #EEF2F5 !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;
  transition: box-shadow 0.2s ease, transform 0.2s ease !important;
  overflow: hidden;
}

.menu-item-grid-card:hover {
  box-shadow: 0 6px 20px rgba(0,188,212,0.15) !important;
  transform: translateY(-3px);
}

.menu-item-grid-header { position: relative; overflow: hidden; }

.status-ok-header     { background: rgba(74,222,128,0.15) !important; }
.status-processing-header { background: rgba(251,191,36,0.15) !important; }
.status-failed-header { background: rgba(248,113,113,0.15) !important; }

.no-image-placeholder {
  height: 165px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F5F7FA;
}

.menu-item-grid-content  { padding: 16px; min-height: 110px; }
.menu-item-grid-title    { font-size: 16px !important; font-weight: 600 !important; color: #334155 !important; margin-bottom: 4px !important; }
.menu-item-grid-status   { font-size: 13px !important; font-weight: 500 !important; margin-bottom: 4px !important; }
.menu-item-grid-price    { font-size: 13px !important; font-weight: 500 !important; color: #64748B !important; margin-bottom: 4px !important; }
.menu-item-grid-actions  { padding: 8px 16px !important; }

/* One Liner Text */
.one-liner-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
